import React, { useEffect, useState } from "react";

const TopToBtn = () => {
  const [visible, setVisible] = useState(false);

  // Show button only when scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth effect
    });
  };

  return (
    <>
      <style>{`
        .top-btn {
          position: fixed;
          bottom: 100px;
          right: 20px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: linear-gradient(90deg, rgb(31, 38, 97), rgb(18, 40, 148), rgb(31, 104, 213));

          color: white;
          border: none;
          cursor: pointer;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
          transition: transform 0.3s ease, background 0.3s ease;
          z-index: 1000;
          box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.4);
        }

        .top-btn:hover {
          transform: scale(1.02) rotate(2deg);
          background: linear-gradient(145deg, rgb(31, 104, 213), rgb(31, 38, 97), rgb(18, 40, 148) );
        }

        .top-btn:active {
          transform: scale(0.9);
        }

        /* Smooth fade-in/out */
        .fade-in {
          opacity: 1;
          visibility: visible;
          transition: opacity 0.4s ease, visibility 0.4s ease;
        }

        .fade-out {
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.4s ease, visibility 0.4s ease;
        }
      `}</style>

      <button
        className={`top-btn ${visible ? "fade-in" : "fade-out"}`}
        onClick={scrollToTop}
      >
        ↑
      </button>
    </>
  );
};

export default TopToBtn;
